import type { ReactNode } from 'react';

interface AppBarProps {
  leading?: ReactNode;
  center?: ReactNode;
  trailing?: ReactNode;
}

/**
 * AppBar — three-slot shell that sits sticky at the top of every page.
 * Owns the height, hairline divider, padding and grid rhythm; the slot
 * content (breadcrumb, live indicators, pill switch, …) is filled by
 * feature-scoped wrappers so the same visual frame works for every
 * screen.
 */
export function AppBar({ leading, center, trailing }: Readonly<AppBarProps>): React.JSX.Element {
  return (
    <header className="sticky top-0 z-10 grid grid-cols-topbar items-center gap-4 border-b border-border-soft bg-paper px-6 min-h-topbar-h">
      <div className="inline-flex min-w-0 items-center">{leading}</div>
      <div className="inline-flex items-center justify-center">{center}</div>
      <div className="inline-flex items-center justify-end">{trailing}</div>
    </header>
  );
}
